angular.module('gym.calendar').factory('EditEventService', ["$modal", "isInteger", function($modal, isInteger) {
  return {
    getEventRepeatIntervalUnits: function() {
      return [['day', 'day(s)', 'Daily'], ['week', 'week(s)', 'Weekly'], ['month', 'month(s)', 'Monthly']];
    },
    getRestrictCancellationsUnits: function() {
      return [['minute', 'minute(s)'], ['hour', 'hour(s)'], ['day', 'day(s)']];
    },
    getBookingsAllowedAfterUnits: function() {
      return [['hour', 'hour(s)'], ['day', 'day(s)'], ['week', 'week(s)'], ['month', 'month(s)']];
    },
    getBookingsAllowedBeforeUnits: function() {
      return [['minute', 'minute(s)'], ['hour', 'hour(s)'], ['day', 'day(s)']];
    },
    getDays: function() {
      return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    },
    manageLocations: function(classrooms) {
      return $modal.open({
        template: require('templates/gyms/calendar/events/manage_locations.html.slim'),
        controller: 'ClassroomMgmtModalCtrl',
        resolve: {
          classrooms: function() {
            return classrooms;
          }
        }
      });
    },
    manageTypes: function(eventTypes) {
      var roomModal;
      return roomModal = $modal.open({
        template: require('templates/gyms/calendar/events/manage_types.html.slim'),
        controller: 'ManageEventTypesModal',
        resolve: {
          types: function() {
            return eventTypes;
          }
        }
      });
    },
    removeRepeat: function(event) {
      event.repeats = null;
      event.repeat_until = null;
      event.repeat_until_date = null;
      event.infinite = null;
      return event.repeat_interval_unit = null;
    },
    repeatTypeChanged: function(event) {
      switch (event.repeat_type) {
        case 'count':
          event.repeats || (event.repeats = 1);
          event.repeat_until = null;
          event.repeat_until_date = null;
          return event.infinite = null;
        case 'until':
          event.repeat_until || (event.repeat_until = moment().format('YYYY-MM-DD'));
          event.repeat_until_date || (event.repeat_until_date = moment().format('YYYY-MM-DD'));
          event.repeats = null;
          return event.infinite = null;
        case 'infinite':
          event.infinite = true;
          event.repeats = null;
          event.repeat_until = null;
          return event.repeat_until_date = null;
      }
    },
    onIntervalUnitChanged: function(event) {
      var day;
      if (event.repeat_interval_unit === 'week') {
        day = moment().day();
        event.repeat_type = 'until';
        event.duration_hours || (event.duration_hours = '1');
        event.duration_minutes || (event.duration_minutes = '00');
        return this.setDailySession(event, day);
      } else {
        event.wdays = [];
        event.daily_sessions = {};
        event.duration_hours = void 0;
        return event.duration_minutes = void 0;
      }
    },
    isParticipantLimitValid: function(event) {
      return isInteger(event.participant_limit) && isInteger(event.prospect_participant_limit) && event.participant_limit >= 0 && event.prospect_participant_limit >= 0 && event.participant_limit >= event.prospect_participant_limit;
    },
    getDailySession: function(event, startTime) {
      var durationHours, durationMinutes, endTime, start;
      startTime = startTime || event.start_time || event.start_at;
      start = moment(startTime);
      durationHours = event.duration_hours || '0';
      durationMinutes = event.duration_minutes || '0';
      endTime = start.clone().add(durationHours, 'hours').add(durationMinutes, 'minutes');
      return {
        start_at: start.format('h:mma'),
        start_at_obj: start.toDate(),
        end_at: endTime.format('h:mma'),
        end_at_obj: endTime.toDate()
      };
    },
    setDailySession: function(event, day) {
      event.wdays = [day];
      event.daily_sessions = {};
      return event.daily_sessions[day] = [this.getDailySession(event)];
    },
    onDailySessionStartTimeChanged: function(session) {
      if (!moment(session.start_at_obj).isValid()) {
        session.start_at_obj = moment().toDate();
      }
      return session.start_at = moment(session.start_at_obj).format('h:mma');
    },
    onDailySessionEndTimeChanged: function(session) {
      if (!moment(session.end_at_obj).isValid()) {
        session.end_at_obj = moment().toDate();
      }
      return session.end_at = moment(session.end_at_obj).format('h:mma');
    },
    isDaySelected: function(event, index) {
      var result;
      result = _.find(event.wdays, function(day) {
        return day === index;
      });
      return result != null;
    },
    toggleDay: function(event, index) {
      var isDailySession;
      isDailySession = !event.id || event.multiple_sessions_per_day;
      event.wdays || (event.wdays = []);
      if (isDailySession) {
        event.daily_sessions || (event.daily_sessions = {});
      }
      if (this.isDaySelected(event, index)) {
        event.wdays = _.without(event.wdays, index);
        if (isDailySession) {
          return event.daily_sessions[index] = void 0;
        }
      } else {
        event.wdays.push(index);
        if (isDailySession) {
          return event.daily_sessions[index] = [this.getDailySession(event)];
        }
      }
    },
    isCopyDaySelected: function(dayIndex, copyDay, dailySessionWdays) {
      var days;
      days = dailySessionWdays[dayIndex];
      return _.find(days, function(day) {
        return day === copyDay;
      }) != null;
    },
    toggleCopyDay: function(dayIndex, copyDayIndex, dailySessionWdays) {
      var day;
      day = dailySessionWdays[dayIndex];
      if (this.isCopyDaySelected(dayIndex, copyDayIndex, dailySessionWdays)) {
        return dailySessionWdays[dayIndex] = _.without(day, copyDayIndex);
      } else {
        dailySessionWdays[dayIndex].push(copyDayIndex);
        return dailySessionWdays[dayIndex] = _.sortBy(dailySessionWdays[dayIndex], function(day) {
          return day;
        });
      }
    },
    copySession: function(event, day, wdays) {
      return _.each(wdays[day], (copyDay) => {
        var copy;
        copy = angular.copy(event.daily_sessions[day]);
        event.daily_sessions[copyDay] = copy.map(function(d) {
          d.editable = true;
          return d;
        });
        if (!this.isDaySelected(event, copyDay)) {
          return event.wdays.push(copyDay);
        }
      });
    },
    isWeeklyEventReady: function(event) {
      return event.wdays.length && (event.repeats || event.repeat_until || event.repeat_until_date || event.repeat_type === 'infinite');
    }
  };
}]);
